import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useConfirmSatisfaction } from '@/hooks/useRequests'
import routes from '@/routes/routes'
import useModalStore from '@/stores/ModalStore'

import Button from '@/components/common/Button/Button'
import './ServiceConfirmation.css'

interface ServiceConfirmationProps {
    serviceRequestId: number
    serviceName: string
    providerName: string
}

const ServiceConfirmation = ({ serviceRequestId, serviceName, providerName }: ServiceConfirmationProps) => {
    const [showComplaint, setShowComplaint] = useState(false)
    const confirmMutation = useConfirmSatisfaction()
    const closeModal = useModalStore((s) => s.closeModal)
    const navigate = useNavigate()

    const handleConfirm = async () => {
        try {
            await confirmMutation.mutateAsync({ requestId: serviceRequestId, satisfied: true })
            closeModal()
            navigate(routes.reviewDetail.replace(':id', String(serviceRequestId)))
        } catch {
            // handled by interceptor/toast in higher layers if needed
        }
    }

    const handleFileComplaint = async () => {
        try {
            await confirmMutation.mutateAsync({ requestId: serviceRequestId, satisfied: false })
            closeModal()
            navigate({ pathname: routes.complaintCreate, search: `?serviceRequestId=${serviceRequestId}&serviceName=${encodeURIComponent(serviceName)}&providerName=${encodeURIComponent(providerName)}` })
        } catch {
            // handled upstream
        }
    }

    return (
        <div className="serviceconfirm_container">
            <div className="serviceconfirm_icon">✓</div>
            <h3 className="serviceconfirm_title">Servicio Finalizado</h3>
            <div className="serviceconfirm_info">
                <div className="serviceconfirm_name">{serviceName}</div>
                <div className="serviceconfirm_provider">Proveedor: {providerName}</div>
            </div>
            <p className="serviceconfirm_text">Por favor confirma que el servicio se completó correctamente y estás satisfecho.</p>
            
            <div className="serviceconfirm_warning">
                ⚠️ Esta confirmación es obligatoria para continuar usando la app
            </div>

            <div className="serviceconfirm_actions">
                <Button variant="success" size="lg" onClick={handleConfirm} disabled={confirmMutation.isPending}>
                    {confirmMutation.isPending ? 'Enviando...' : '👍 Servicio Completado Satisfactoriamente'}
                </Button>
                {!showComplaint ? (
                    <button className="serviceconfirm_link" onClick={() => setShowComplaint(true)}>¿Algo salió mal?</button>
                ) : (
                    <Button variant="danger" size="lg" onClick={handleFileComplaint} disabled={confirmMutation.isPending}>
                        ⚠️ No estoy satisfecho - Presentar queja
                    </Button>
                )}
            </div>
        </div>
    )
}

export default ServiceConfirmation


